import { stack } from "./global.svelte";

/**
 *
 *
 */
export type Preflight = (
  | {
      /**
 *
 *
 */
      isActive: true;
      /**
 *
 *
 */
      current: string;
    }
  | { isActive: false; current: null }
) &
  (
    | {
        /**
 *
 *
 */
        isContentChange: true;
        /**
 *
 *
 */
        reason: "content-switch";
        /**
 *
 *
 */
        previos: string;
      }
    | { isContentChange: false; reason: "open-close"; previos: null }
  );

const preflightComputePrev = <ID extends string | null>(
  previos: ID,
): ID extends string
  ? { isContentChange: true; previos: ID; reason: "content-switch" }
  : { isContentChange: false; previos: null; reason: "open-close" } =>
  (previos
    ? { isContentChange: true, previos, reason: "content-switch" }
    : { isContentChange: false, previos: null, reason: "open-close" }) as never;

export const preflightPush = (id: string): Preflight => {
  const isActive = !!stack.current && stack.current === id;

  const curr = isActive
    ? ({ isActive: true, current: id } as const)
    : ({ isActive: false, current: null } as const);

  const prev = preflightComputePrev(stack.current);

  return { ...curr, ...prev };
};

export const preflightPop = (): Preflight => {
  const isActive = stack.current !== null;

  const curr = isActive
    ? ({ isActive: true, current: stack.current! } as const)
    : ({ isActive: false, current: null } as const);

  const prev = preflightComputePrev(stack.previous);

  return { ...curr, ...prev };
};
